import React from 'react';
import { SimpleModal } from '../modal';

// interface LogOutProps {
//   open: boolean;
// }

const LogOut = (props) => {
  const { open, onCancel, onOk } = props;
  return (
    <SimpleModal
      visible={open}
      btnGap={16}
      modalText="确定要关闭退出吗？"
      onCancel={onCancel}
      onOk={onOk}
    />
  );
}

export default LogOut;
